/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverridePaymentStateDto
 */
export interface OverridePaymentStateDto {
    /**
     * 
     * @type {OverridePaymentStateDtoNewStateEnum}
     * @memberof OverridePaymentStateDto
     */
    newState: OverridePaymentStateDtoNewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof OverridePaymentStateDto
     */
    reason: string;
}


/**
 * @export
 */
export const OverridePaymentStateDtoNewStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type OverridePaymentStateDtoNewStateEnum = typeof OverridePaymentStateDtoNewStateEnum[keyof typeof OverridePaymentStateDtoNewStateEnum];


/**
 * Check if a given object implements the OverridePaymentStateDto interface.
 */
export function instanceOfOverridePaymentStateDto(value: object): value is OverridePaymentStateDto {
    if (!('newState' in value) || value['newState'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function OverridePaymentStateDtoFromJSON(json: any): OverridePaymentStateDto {
    return OverridePaymentStateDtoFromJSONTyped(json, false);
}

export function OverridePaymentStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverridePaymentStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'newState': json['newState'],
        'reason': json['reason'],
    };
}

export function OverridePaymentStateDtoToJSON(json: any): OverridePaymentStateDto {
    return OverridePaymentStateDtoToJSONTyped(json, false);
}

export function OverridePaymentStateDtoToJSONTyped(value?: OverridePaymentStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newState': value['newState'],
        'reason': value['reason'],
    };
}

